import config from "../config";
import GetArcGISToken from "./GetArcGISToken";

export default function(geometry) {
  let token = GetArcGISToken.token;
  let gisUrl = config.gisUrl;
  let rings = geometry.rings;
  let extent = geometry.extent.expand(2).toJSON();
  return {
    operationalLayers: [
      {
        layerType: "ArcGISTiledMapServiceLayer",
        url: gisUrl + "/Basemap/MapServer",
        id: "18ccd04033f-layer-67",
        title: "Survey Basemap",
        opacity: 1,
        minScale: 0,
        maxScale: 0,
      },
      {
        layerType: "ArcGISMapServiceLayer",
        layers: [
          {
            id: 69,
            name: null,
            layerDefinition: {
              drawingInfo: { transparency: 50 },
              source: { type: "mapLayer", mapLayerId: 69 },
            },
          },
          {
            id: 68,
            name: null,
            layerDefinition: { source: { type: "mapLayer", mapLayerId: 68 } },
          },
          {
            id: 44,
            name: null,
            layerDefinition: { source: { type: "mapLayer", mapLayerId: 44 } },
          },
          {
            id: 43,
            name: null,
            layerDefinition: { source: { type: "mapLayer", mapLayerId: 43 } },
          },
        ],
        url: gisUrl + "/GInfo/SlopeInfo/MapServer",
        token: token,
        id: "18ccd04089e-layer-68",
        title: "SlopeInfo",
        opacity: 1,
        minScale: 0,
        maxScale: 0,
      },
      {
        layerType: "ArcGISMapServiceLayer",
        layers: [
          {
            id: 5,
            name: "200m_label_N",
            layerDefinition: { source: { type: "mapLayer", mapLayerId: 5 } },
          },
          {
            id: 6,
            name: "200m_label_E",
            layerDefinition: { source: { type: "mapLayer", mapLayerId: 6 } },
          },
          {
            id: 12,
            name: "200m cell",
            layerDefinition: { source: { type: "mapLayer", mapLayerId: 12 } },
          },
        ],
        visibleLayers: [12, 6, 5],
        url: gisUrl + "/Overlay/Grid_LabelMethod/MapServer",
        token: token,
        id: "18ccd0408a5-layer-69",
        title: "Grid LabelMethod",
        opacity: 1,
        minScale: 0,
        maxScale: 0,
      },
      {
        featureCollection: {
          layers: [
            {
              layerDefinition: {
                name: "polygonLayer",
                geometryType: "esriGeometryPolygon",
              },
              featureSet: {
                geometryType: "esriGeometryPolygon",
                features: [
                  {
                    aggregateGeometries: null,
                    geometry: {
                      spatialReference: { latestWkid: 2326, wkid: 102140 },
                      rings,
                    },
                    symbol: {
                      type: "esriSFS",
                      color: [51, 51, 204, 26],
                      outline: {
                        type: "esriSLS",
                        color: [0, 0, 255, 255],
                        width: 3,
                        style: "esriSLSSolid",
                      },
                      style: "esriSFSSolid",
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
    mapOptions: {
      extent,
      spatialReference: { latestWkid: 2326, wkid: 102140 },
      showAttribution: true,
      scale: 2000,
    },
    exportOptions: { dpi: 96, outputSize: [746, 1022] },
    layoutOptions: {
      legendOptions: {
        operationalLayers: [
          { id: "18ccd04033f-layer-67" },
          { id: "18ccd04089e-layer-68", subLayerIds: [43, 44, 68, 69] },
          { id: "18ccd0408a5-layer-69", subLayerIds: [12, 6, 5] },
        ],
      },
    },
  };
}
